const ArrowDownFill = require("./arrow.down.fill.svg").default;
const ArrowRightFill = require("./arrow.right.fill.svg").default;
const CalendarOutline = require("./calendar.outline.svg").default;
const CardFill = require("./card.fill.svg").default;
const CardOutline = require("./card.outline.svg").default;
const CheckmarkCircleOutline =
  require("./checkmark.circle.outline.svg").default;
const ChevronDownFill = require("./chevron.down.fill.svg").default;
const ChevronUpFill = require("./chevron.up.fill.svg").default;
const ExportFill = require("./export.fill.svg").default;
const EyeOutline = require("./eye.outline.svg").default;
const EyeSlashOutline = require("./eye.slash.outline.svg").default;
const HeadphonesFill = require("./headphones.fill.svg").default;
const HomeFill = require("./home.fill.svg").default;
const HomeOutline = require("./home.outline.svg").default;
const Lines3Fill = require("./lines.3.fill.svg").default;
const MagnifyingGlassFill = require("./magnifying.glass.fill.svg").default;
const PencilOutline = require("./pencil.outline.svg").default;
const BarcodeFill = require("./barcode.fill.svg").default;
const BarcodeOutline = require("./barcode.outline.svg").default;
const PeopleFill = require("./people.fill.svg").default;
const PeopleOutline = require("./people.outline.svg").default;
const PersonOutline = require("./person.outline.svg").default;
const PlusFill = require("./plus.fill.svg").default;
const ReportFill = require("./reports.fill.svg").default;
const ReportOutline = require("./reports.outline.svg").default;
const SupportFill = require("./support.fill.svg").default;
const SupportOutline = require("./support.outline.svg").default;
const TagFill = require("./tag.fill.svg").default;
const TagOutline = require("./tag.outline.svg").default;
const TrashOutline = require("./trash.outline.svg").default;
const XMarkFill = require("./x.mark.fill.svg").default;

export {
  ArrowDownFill,
  ArrowRightFill,
  CalendarOutline,
  CardFill,
  CardOutline,
  CheckmarkCircleOutline,
  ChevronDownFill,
  ChevronUpFill,
  ExportFill,
  EyeOutline,
  EyeSlashOutline,
  HeadphonesFill,
  HomeFill,
  HomeOutline,
  Lines3Fill,
  MagnifyingGlassFill,
  PencilOutline,
  BarcodeFill,
  BarcodeOutline,
  PeopleFill,
  PeopleOutline,
  PersonOutline,
  PlusFill,
  ReportFill,
  ReportOutline,
  SupportFill,
  SupportOutline,
  TagFill,
  TagOutline,
  TrashOutline,
  XMarkFill,
};
